import { configureStore } from "@reduxjs/toolkit";

// A Redux store is a centralized container that holds the state of your application. 
import Subscription from "./slice/subscriptionSlice"
import menuReducer from "./slice/makeMenuDataSlice";
import staffReducer from "./slice/staffSlice";
import orderReducer from "./slice/orderSlice";
// import notificationReducer from "./slice/profileReducer";
import sseReducer from "./slice/sseSlicer";
import statusReducer from "./slice/statusSlice";
import waiterReducer from "./slice/waiterSlice";
import riderReducer from "./slice/riderSlice";
import orderAssignReducer from "./slice/orderAssignSlice";
import QrOrderReducer from "./slice/qrMenuSlice";
import Items from "./slice/itemSlice";
import MainCourse from "./slice/mainCourseSlice"

const store = configureStore({
  reducer: {
    menu: menuReducer,
    staff:staffReducer,
    orders:orderReducer,
    sse:sseReducer,
    trackStatus:statusReducer,
    waiter:waiterReducer,
    rider:riderReducer,
    orderAssign:orderAssignReducer,
    subscription:Subscription,
    qrOrder:QrOrderReducer,
    items:Items,
    mainCourses:MainCourse


  },
});

export default store;
